import React, { useEffect, useState } from 'react'
import {
  PrevButton,
  NextButton,
  usePrevNextButtons
} from './EmblaCarouselArrowButtons'
import useEmblaCarousel from 'embla-carousel-react'
import star from '../../icons/star.svg'

const EmblaCarousel = (props) => {
  const { slides, options } = props
  const [emblaRef, emblaApi] = useEmblaCarousel(options)
  const [currentSlide, setCurrentSlide] = useState(0)

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)

  useEffect(() => {
    if (!emblaApi) return
    const onSelect = () => {
        setCurrentSlide(emblaApi.selectedScrollSnap())
    }
    emblaApi.on('select', onSelect)
    return () => emblaApi.off('select', onSelect)
}, [emblaApi])

  return (
    <section className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {slides.map((i, index) => (
            <div className={`embla__slide ${currentSlide === index ? 'embla__slide--active' : 'embla__slide--inactive'}`} key={index}>
              <div className="embla__slide__number">
                <p className='carousel-comment'>"{i.comment}"</p>
                <div className='review'>
                    <div className='stars'>
                    <img src={star} alt="star" className='star-icon' />
                    <img src={star} alt="star" className='star-icon' />
                    <img src={star} alt="star" className='star-icon' />
                    <img src={star} alt="star" className='star-icon' />
                    <img src={star} alt="star" className='star-icon' />
                  </div>
                     <p className='carousel-name'>{i.name}</p>
                 </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="embla__controls">
        <div className="embla__buttons">
          <PrevButton  onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>

        {/* <div className="embla__dots">
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={'embla__dot'.concat(
                index === selectedIndex ? ' embla__dot--selected' : ''
              )}
            />
          ))}
        </div> */}
      </div>
    </section>
  )
}

export default EmblaCarousel
